/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Calendar_SubscribeInputs */



/**
* | output |
* | --- |
* | "Subscribe (.ics)" |
*
* @param {League_Calendar_SubscribeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_calendar_subscribe = /** @type {((inputs?: League_Calendar_SubscribeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Calendar_SubscribeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'abonner (.ics)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suscribirse (.ics)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assinar (.ics)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscriviti (.ics)")
	return /** @type {LocalizedString} */ ("Subscribe (.ics)")
});